/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkboxgroup[_ngcontent-%COMP%]{display:inline-block;text-align:center}.checkboxgroup[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:block}"];
export { styles as styles };
